import { AUTH_USER_STORAGE_KEY } from "@/lib/auth-storage";

export const ACTIVE_USER_CHANGED_EVENT = "nebula:active-user-changed";

export function readActiveUserID(): string {
  if (typeof window === "undefined") return "";
  try {
    const raw = window.localStorage.getItem(AUTH_USER_STORAGE_KEY);
    if (!raw) return "";
    const parsed = JSON.parse(raw) as { id?: string };
    return String(parsed?.id || "").trim();
  } catch {
    return "";
  }
}

export function scopedStorageKey(baseKey: string, userID?: string): string {
  const scoped = String((userID ?? readActiveUserID()) || "guest").trim() || "guest";
  return `${baseKey}:${scoped}`;
}

export function emitActiveUserChanged(userID: string) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(ACTIVE_USER_CHANGED_EVENT, {
      detail: { userID: String(userID || "").trim() },
    }),
  );
}

export function onActiveUserChanged(handler: (userID: string) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const listener = (event: Event) => {
    const custom = event as CustomEvent<{ userID?: string }>;
    handler(String(custom.detail?.userID || "").trim());
  };
  window.addEventListener(ACTIVE_USER_CHANGED_EVENT, listener as EventListener);
  const storageListener = (event: StorageEvent) => {
    if (event.key !== AUTH_USER_STORAGE_KEY) return;
    handler(readActiveUserID());
  };
  window.addEventListener("storage", storageListener);
  return () => {
    window.removeEventListener(ACTIVE_USER_CHANGED_EVENT, listener as EventListener);
    window.removeEventListener("storage", storageListener);
  };
}
